import React from 'react'

import conditions from '../../../constants/conditions'
import { useSelector } from '../../../modules/store/customSelector'
import { storeDispatchTypes } from '../../../modules/store/storeDispatchTypes'
import TableHeadSelectSearch from '../../_atoms/TableHeadSelectSearch/TableHeadSelectSearch'

const TableHeadConditionSearchParts = () => {
    const conditionIdFilter = useSelector(state => state.partList.filters.conditionId)

    const conditionOptions = conditions.map(condition => ({
        value: String(condition.id),
        name: condition.title,
    }))

    // Заглушка для searchOptions, так как справочник состояний статический
    const searchConditions = () => async () => {
        // Ничего не делаем, так как все опции уже переданы в options
    }

    return (
        <TableHeadSelectSearch
            slice={'partList'}
            tableHead={'Состояние'}
            placeholder={'Выберите состояние'}
            actionType={storeDispatchTypes.setConditionFilterParts}
            options={conditionOptions}
            filterId={conditionIdFilter}
            searchOptions={searchConditions}
        />
    )
}

export default TableHeadConditionSearchParts

